import React from "react";
import { Tooltip, Box } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const tooltipSlotProps = {
  tooltip: {
    sx: {
      maxWidth: 420,
      fontSize: "13px",
      lineHeight: 1.55,
      whiteSpace: "pre-line",
      bgcolor: "#1E1E1E",
      color: "#FFFFFF",
      border: "1px solid rgba(13, 163, 226, 0.45)",
      boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
      p: 1.25,
    },
  },
};

export default function FieldHelpTooltip({
  title,
  placement = "top",
  iconSize = 18,
  sx,
}) {
  if (!title) return null;

  return (
    <Tooltip title={title} placement={placement} arrow slotProps={tooltipSlotProps}>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          verticalAlign: "middle",
          ml: 0.5,
          cursor: "help",
          ...sx,
        }}
      >
        <HelpOutlineIcon
          sx={{ fontSize: iconSize, color: "rgba(255,255,255,0.65)" }}
        />
      </Box>
    </Tooltip>
  );
}
